var _path, _path2, _path3, _polygon, _polygon2, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStudentsRafiki(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-36"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.4,337.8H45.3a5.71,5.71,0,0,1-5.71-5.71V60.66A5.71,5.71,0,0,1,45.3,55H238.4a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,238.4,337.8ZM45.3,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46H238.4a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.7,337.8H261.6a5.71,5.71,0,0,1-5.71-5.71V60.66A5.71,5.71,0,0,1,261.6,55H454.7a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,454.7,337.8ZM261.6,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46H454.7a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 282.97,
    y: 251.47,
    width: 159.48,
    height: 131.02,
    transform: "translate(725.43 633.96) rotate(180)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.97 254.16 448.9 254.16 419.37 215.49 282.97 215.49 282.97 254.16",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.45,343.38a13.24,13.24,0,0,1,26.48,0v32.67H402.45Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.86,343.38a13.24,13.24,0,1,1,26.48,0v32.67H355.86Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.27,343.38a13.24,13.24,0,1,1,26.47,0v32.67H309.27Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.45,272.38a13.24,13.24,0,0,1,26.48,0v32.67H402.45Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.86,272.38a13.24,13.24,0,1,1,26.48,0v32.67H355.86Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.27,272.38a13.24,13.24,0,1,1,26.47,0v32.67H309.27Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.3,
    y: 310.03,
    width: 159.61,
    height: 7.51,
    transform: "translate(738.2 627.56) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 251.47,
    width: 159.48,
    height: 131.02,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.49 254.16 52.56 254.16 82.09 215.49 218.49 215.49 218.49 254.16",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,343.38a13.24,13.24,0,0,0-26.48,0v32.67H99Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.6,343.38a13.24,13.24,0,1,0-26.48,0v32.67H145.6Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.19,343.38a13.24,13.24,0,1,0-26.47,0v32.67h26.47Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,272.38a13.24,13.24,0,0,0-26.48,0v32.67H99Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.6,272.38a13.24,13.24,0,1,0-26.48,0v32.67H145.6Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.19,272.38a13.24,13.24,0,1,0-26.47,0v32.67h26.47Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.56,
    y: 310.03,
    width: 159.61,
    height: 7.51,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.3,
    y: 266.39,
    width: 99.34,
    height: 116.11,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.29 262.88 213.65 262.88 213.65 175.64 250.97 143 288.29 175.64 288.29 262.88",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.5,324.44a23.53,23.53,0,0,0-47.05,0v58.05H274.5Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.01,
    y: 259.55,
    width: 107.93,
    height: 7.51,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250.97,
    cy: 186.5,
    r: 22.55,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.82,191.37H248l.57-21.65a1.33,1.33,0,0,1,1.33-1.29h0a1.31,1.31,0,0,1,1.32,1.29Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,191.37v-3.8l15.29.57c.51,0,.91.61.91,1.33h0c0,.72-.4,1.3-.91,1.32Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69,110c24.48,9.51,103.71-1.33,103.27-19.33C171.49,57.2,144,86,144,86s-9.74-17.33-24.36-18.67-17.16,19.34-17.16,19.34S87.67,79.33,81,81.33s-6.94,14-6.94,14S47.69,101.7,69,110Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.17,130.4c23.06,12.59,103,12,104.9-5.9,3.49-33.29-27.49-8.27-27.49-8.27s-7.43-18.44-21.76-21.64-19.5,17-19.5,17-13.73-9.17-20.6-8-8.69,13-8.69,13S174.06,119.43,194.17,130.4Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.81,108.69c10.55,7.56,48.15,5.37,49.44-6.2,2.4-21.5-12.73-4.69-12.73-4.69s-3.07-11.7-9.73-13.43-9.56,11.36-9.56,11.36-6.24-5.58-9.5-4.7-4.37,8.55-4.37,8.55S326.61,102.09,335.81,108.69Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.24,133.76c12.54,9,57.24,6.38,58.78-7.36,2.85-25.56-15.14-5.58-15.14-5.58s-3.65-13.91-11.57-16S399,118.36,399,118.36s-7.42-6.64-11.29-5.59-5.21,10.17-5.21,10.17S367.3,125.91,378.24,133.76Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-36"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-36",
    cx: 250,
    cy: 415.69,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279,208.4h23a18.6,18.6,0,0,1,18.53,16.75s0,.09,0,.13c1.16,12.92,1,39,0,51.9,0,.52-.1,1.16-.19,1.87A18.46,18.46,0,0,1,302,295.31H269.78a18.31,18.31,0,0,1-17.45-12.4,7.84,7.84,0,0,1-.25-.86c-1.49-6.52-2-20.39,0-26.78,1.12-3.56,7.41-8.69,8.52-12.25,1.73-5.5-2.2-17.73,0-23.06.73-1.76,3.31-4.41,5.85-6.72A18.57,18.57,0,0,1,279,208.4Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279,208.4h23a18.6,18.6,0,0,1,18.53,16.75s0,.09,0,.13c1.16,12.92,1,39,0,51.9,0,.52-.1,1.16-.19,1.87A18.46,18.46,0,0,1,302,295.31H269.78a18.31,18.31,0,0,1-17.45-12.4,7.84,7.84,0,0,1-.25-.86c-1.49-6.52-2-20.39,0-26.78,1.12-3.56,7.41-8.69,8.52-12.25,1.73-5.5-2.2-17.73,0-23.06.73-1.76,3.31-4.41,5.85-6.72A18.57,18.57,0,0,1,279,208.4Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.81,212.36a3.33,3.33,0,0,0-1.05-.89,17.9,17.9,0,0,0-2.31,1.77c-2.54,2.31-5.12,5-5.85,6.72-2.2,5.33,1.73,17.56,0,23.06-1.11,3.56-7.4,8.69-8.52,12.25-2,6.39-1.49,20.26,0,26.78a7.84,7.84,0,0,0,.25.86,18.2,18.2,0,0,0,14.43,12.15,6.19,6.19,0,0,0,1.7-1.14C271.17,291.16,273.35,217.49,269.81,212.36Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.81,212.36a3.33,3.33,0,0,0-1.05-.89,17.9,17.9,0,0,0-2.31,1.77c-2.54,2.31-5.12,5-5.85,6.72-2.2,5.33,1.73,17.56,0,23.06-1.11,3.56-7.4,8.69-8.52,12.25-2,6.39-1.49,20.26,0,26.78a7.84,7.84,0,0,0,.25.86,18.2,18.2,0,0,0,14.43,12.15,6.19,6.19,0,0,0,1.7-1.14C271.17,291.16,273.35,217.49,269.81,212.36Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.74,285.1,255.37,282a3.54,3.54,0,0,1-2-3.18V265.17a3.53,3.53,0,0,1,3.53-3.53h7a3.53,3.53,0,0,1,3.53,3.65l-.6,16.76A3.52,3.52,0,0,1,261.74,285.1Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "335.72 389.86 323.19 390.9 325.31 405.63 335.79 404.77 335.72 389.86",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.77,346.51c-4.89-18.84-19.63-41-9.84-58.29l34.94,3.26s1.28,32.82,1.52,50.44c.26,18.33-1.32,53-1.32,53L322.71,396S312.92,367.66,311.77,346.51Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.77,346.51c-4.89-18.84-19.63-41-9.84-58.29l34.94,3.26s1.28,32.82,1.52,50.44c.26,18.33-1.32,53-1.32,53L322.71,396S312.92,367.66,311.77,346.51Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,396.53l15.51-1.14a.55.55,0,0,0,.51-.51l.33-5.76a.54.54,0,0,0-.61-.57l-17.22,2.29a.54.54,0,0,0-.45.69l1.37,4.61A.53.53,0,0,0,322,396.53Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.06,304.91a95.47,95.47,0,0,0,.54,13.34c1.72,5.93,3.91,11.86,5.87,17.62C311.05,319.57,311.06,300.57,302.06,304.91Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.93 388.09 268.97 384.18 264.21 398.24 274.2 401.52 280.93 388.09",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,340.41c-1.7-19.05-8-46.88-1.09-55l40.88,4s-8.06,35.58-11.5,53.16C299.72,360.78,279.4,393,279.4,393l-12.9-4.31S270.66,362.15,275,340.41Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,340.41c-1.7-19.05-8-46.88-1.09-55l40.88,4s-8.06,35.58-11.5,53.16C299.72,360.78,279.4,393,279.4,393l-12.9-4.31S270.66,362.15,275,340.41Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.45,388.83l14.6,4.93a.52.52,0,0,0,.62-.24l2.71-4.86a.56.56,0,0,0-.34-.81l-16.13-4.66a.52.52,0,0,0-.65.37l-1.18,4.59A.57.57,0,0,0,265.45,388.83Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.45,246.81l-2.76.21a1.53,1.53,0,0,0-.43.19l-.49.25c-.32.18-.64.34-1,.5-.64.33-1.29.62-1.91.87a13,13,0,0,1-1.95.64l-.6-11c-.1-2.19-.26-4.37-.39-6.56s-.3-4.4-.5-6.49v-.14a8.53,8.53,0,0,0-17,1c0,2.38.2,4.61.38,6.9s.42,4.55.73,6.82l.45,3.41.55,3.4c.35,2.27.81,4.53,1.27,6.8l.21,1a5.24,5.24,0,0,0,.79,1.84,17,17,0,0,0,3,3.42,13.47,13.47,0,0,0,4.75,2.68,12.32,12.32,0,0,0,5.4.42,14.18,14.18,0,0,0,4.21-1.31,19.15,19.15,0,0,0,5.4-4.17,25.72,25.72,0,0,0,1.9-2.35c.29-.41.56-.82.82-1.24l.39-.65.41-.72a3.79,3.79,0,0,0,.49-2.19A3.84,3.84,0,0,0,344.45,246.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.45,216.34c6.54,5.47,7.13,24.23,7.13,24.23-2.94,6.05-9.94,7.05-15.91,8,0,0-7.6-5.09-9.25-18.45C312.21,220.27,318.24,205.27,331.45,216.34Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M331.45,216.34c6.54,5.47,7.13,24.23,7.13,24.23-2.94,6.05-9.94,7.05-15.91,8,0,0-7.6-5.09-9.25-18.45C312.21,220.27,318.24,205.27,331.45,216.34Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M323,212a158.44,158.44,0,0,0-34.87-2.81c-6.76.29-11.88,4-12.39,17.75-1,27.9-5.67,49.28-3.1,59.6,0,0,49.92,19.67,65.93,7,6.78-33-2.52-61.91-6.87-74A11.73,11.73,0,0,0,323,212Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.36,399.51H324.78a.74.74,0,0,0-.75.65l-1.21,8.37a1.52,1.52,0,0,0,1.51,1.68c3.69-.07,5.47-.28,10.12-.28,2.87,0,7.22.29,11.18.29s4.16-3.91,2.52-4.26c-7.39-1.59-8.72-3.78-11.21-5.87A2.45,2.45,0,0,0,335.36,399.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.9,401.16a3.59,3.59,0,0,0,2.29-.58,1.26,1.26,0,0,0,.4-1.09.74.74,0,0,0-.38-.59c-1.15-.63-4.91,1.28-5.33,1.5a.21.21,0,0,0-.12.23.21.21,0,0,0,.18.19A15.87,15.87,0,0,0,338.9,401.16Zm1.68-2a.88.88,0,0,1,.42.08.27.27,0,0,1,.14.24.8.8,0,0,1-.25.72c-.57.51-2.12.6-4.21.25A12.1,12.1,0,0,1,340.58,399.21Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336,400.83l.09,0c1.12-.51,3.35-2.54,3.17-3.61,0-.25-.22-.57-.84-.63a1.6,1.6,0,0,0-1.23.38c-1.19,1-1.41,3.53-1.41,3.63a.22.22,0,0,0,.09.21A.28.28,0,0,0,336,400.83Zm2.24-3.82h.14c.4,0,.43.21.44.26.1.64-1.4,2.24-2.55,2.93a5.21,5.21,0,0,1,1.2-2.9A1.16,1.16,0,0,1,338.22,397Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.07,396l-10.19-2.86a.75.75,0,0,0-.9.42l-3.42,7.74a1.51,1.51,0,0,0,1,2c3.57.93,16.55,5,20.36,6s5.07-2.64,3.57-3.42c-6.68-3.53-7.23-6.27-9.06-9A2.47,2.47,0,0,0,276.07,396Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279,398.58a3.62,3.62,0,0,0,2.36.06,1.25,1.25,0,0,0,.68-.94.71.71,0,0,0-.2-.67c-.94-.93-5.08-.09-5.55,0a.21.21,0,0,0-.17.19.21.21,0,0,0,.12.22A16,16,0,0,0,279,398.58Zm2.15-1.43a.91.91,0,0,1,.37.19.28.28,0,0,1,.08.28.81.81,0,0,1-.44.62c-.69.34-2.2,0-4.12-.89A12.15,12.15,0,0,1,281.18,397.15Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.31,397.47h.09c1.22-.18,3.91-1.54,4-2.61,0-.26-.06-.61-.64-.84a1.65,1.65,0,0,0-1.29,0c-1.41.63-2.3,3-2.34,3.12a.23.23,0,0,0,0,.22A.21.21,0,0,0,276.31,397.47Zm3.19-3.07.13,0c.38.15.36.31.36.37-.08.64-2,1.78-3.25,2.13a5.2,5.2,0,0,1,1.94-2.47A1.12,1.12,0,0,1,279.5,394.4Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.3,258.16c-.47,4.74-.89,9.07-1.16,12.95,4.81.72,13.1-1.54,26.31-14.89l-3.71-2.1Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.81,214.64c-1.21-1.43-2.67-.81-3.13-2.84a6.82,6.82,0,0,1,1.17-4.44l-15-10.08c-.25,5.86-.46,10.48-3.26,12.55-1.17,4.27,6.46,9.38,17.27,10.49C322.71,221,320.54,216.7,318.81,214.64Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.57,207.83l-12.21-4.34c2.68,5.28,8.11,8.55,11.29,7.64A6.72,6.72,0,0,1,316.57,207.83Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.14,178.81c-8.1-2.63-15.9,3.55-15,11.2s1.66,12.82,6.59,15.87c9.81,6.07,15.31,1.66,16.91-6.09C324,192.81,322.37,181.48,314.14,178.81Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.71,200.25a6.4,6.4,0,0,0,1.05-.06.21.21,0,0,0,.18-.23.21.21,0,0,0-.24-.18,5.61,5.61,0,0,1-4.81-1.6.21.21,0,0,0-.29,0,.2.2,0,0,0,0,.29A5.76,5.76,0,0,0,314.71,200.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.58,192.17c0,.67.41,1.2.85,1.17s.77-.58.74-1.25-.41-1.2-.85-1.18S312.55,191.5,312.58,192.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.46,191.88c0,.67.41,1.2.84,1.17s.78-.58.75-1.25-.41-1.2-.85-1.18S320.43,191.21,320.46,191.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.82,192.34l-.17,5.64a3.51,3.51,0,0,0,2.91-.47A11.48,11.48,0,0,0,317.82,192.34Z",
    style: {
      fill: "#ba4d3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.16,190.4a.35.35,0,0,1-.2,0,.39.39,0,0,1-.22-.51,4,4,0,0,1,2.64-2.47.39.39,0,1,1,.17.77h0a3.18,3.18,0,0,0-2.07,2A.41.41,0,0,1,310.16,190.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.29,189.16A.43.43,0,0,1,323,189a3.06,3.06,0,0,0-2.36-1.58.39.39,0,0,1-.38-.41.41.41,0,0,1,.41-.38,3.9,3.9,0,0,1,3,2,.39.39,0,0,1-.13.54A.46.46,0,0,1,323.29,189.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303,196.74s3,1,2.51-3.4a66,66,0,0,1,.05-10.11s19.65,2.09,17.78-3.92c-1-3.32-5.18.19-5.18.19s1.83-3.86-.83-4.64c-2.29-.67-3.16,3-3.16,3s-14.65-3.94-16.78,6.65S303,196.74,303,196.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.09,174.78c-9.14,8.1-4,15.58-.63,19-1.7,2.23-5.79,8-4.14,9.72s4.91-5.33,6.05-8l.31.24s2.22-9.9,16.49-17.88C314.17,177.83,306.66,165.41,296.09,174.78Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.4,176.73a18.2,18.2,0,0,0-1.8-2,3.43,3.43,0,0,0-3.11.32c-2.63,1.54-1.6,3.52-.4,4.85A27.84,27.84,0,0,1,313.4,176.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.34,179.25c-3.51,6.28.35,11.72,3.1,14.49l2.34-3.12A24.79,24.79,0,0,1,292.34,179.25Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.41,189.21a2.72,2.72,0,0,0-2.44,2.56,1.61,1.61,0,0,0-1.68,0,3.12,3.12,0,0,0-6.18.39H299.9v.39h11.21a3.12,3.12,0,0,0,6.24-.2s0-.09,0-.13a1.2,1.2,0,0,1,1.59,0s0,.08,0,.12c0,1.73,1.12,3.13,2.49,3.13s2.49-1.4,2.49-3.13S322.78,189.21,321.41,189.21Zm-7.19,5.88a2.75,2.75,0,1,1,2.74-2.75A2.75,2.75,0,0,1,314.22,195.09Zm7.19,0c-1.16,0-2.1-1.23-2.1-2.75s.94-2.74,2.1-2.74,2.11,1.23,2.11,2.74S322.57,195.09,321.41,195.09Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.41,189.21a2.72,2.72,0,0,0-2.44,2.56,1.61,1.61,0,0,0-1.68,0,3.12,3.12,0,0,0-6.18.39H299.9v.39h11.21a3.12,3.12,0,0,0,6.24-.2s0-.09,0-.13a1.2,1.2,0,0,1,1.59,0s0,.08,0,.12c0,1.73,1.12,3.13,2.49,3.13s2.49-1.4,2.49-3.13S322.78,189.21,321.41,189.21Zm-7.19,5.88a2.75,2.75,0,1,1,2.74-2.75A2.75,2.75,0,0,1,314.22,195.09Zm7.19,0c-1.16,0-2.1-1.23-2.1-2.75s.94-2.74,2.1-2.74,2.11,1.23,2.11,2.74S322.57,195.09,321.41,195.09Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.58,196.52a6.83,6.83,0,0,0,4.2,3.11c2.34.56,3.44-1.56,2.73-3.72-.64-1.94-2.62-4.58-4.94-4.17A3.1,3.1,0,0,0,296.58,196.52Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.36,210.75c-2.57-2.69-6.94-3.08-10.49-2.25v.68c3.27.3,8.64,2.69,9.77,17.42,1.49,19.47-19.53,43-26.05,49.56a7,7,0,0,0-2,4.41l-.26,3.37a1.88,1.88,0,0,0,3.08,1.59c8.86-7.37,32-29.08,32-55C304.36,219.9,301.48,214,298.36,210.75Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.36,210.75c-2.57-2.69-6.94-3.08-10.49-2.25v.68c3.27.3,8.64,2.69,9.77,17.42,1.49,19.47-19.53,43-26.05,49.56a7,7,0,0,0-2,4.41l-.26,3.37a1.88,1.88,0,0,0,3.08,1.59c8.86-7.37,32-29.08,32-55C304.36,219.9,301.48,214,298.36,210.75Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.6,250.7a4.27,4.27,0,0,0-5.36-2.79l-.2.06c-2.41.76-5,1.62-7.42,2.34s-4.92,1.42-7.3,1.93c-1.18.25-2.34.49-3.46.64-.73.09-1.43.16-2.09.19.09-.63.2-1.27.36-1.93a26.72,26.72,0,0,1,.93-3.12c.35-1.06.79-2.14,1.26-3.22a66.29,66.29,0,0,1,3.33-6.48c.61-1.08,1.28-2.14,1.94-3.19l1-1.55.5-.75.42-.62.32-.46a8.52,8.52,0,0,0-13.79-10l-.82,1.08-.72,1c-.47.65-.91,1.31-1.34,2-.88,1.31-1.68,2.67-2.46,4s-1.48,2.79-2.17,4.23-1.32,2.93-1.88,4.47a44.59,44.59,0,0,0-2.55,9.85,31.66,31.66,0,0,0-.33,5.47,30.18,30.18,0,0,0,.73,5.8l.1.44a7,7,0,0,0,1.35,2.76,12.54,12.54,0,0,0,4,3.27,13,13,0,0,0,4.06,1.29,19.55,19.55,0,0,0,6.23-.11,29.23,29.23,0,0,0,4.88-1.24c1.5-.51,2.92-1.06,4.29-1.68a66.46,66.46,0,0,0,7.71-4.12,68.79,68.79,0,0,0,7-4.94A4.29,4.29,0,0,0,300.6,250.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.56,211.25C266.93,218.43,261,234.62,261,234.62c2.66,5.14,15.74,9.24,21.84,7.75,0,0,9-9.05,10.27-18.59C294.27,215,288.55,207,280.56,211.25Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M280.56,211.25C266.93,218.43,261,234.62,261,234.62c2.66,5.14,15.74,9.24,21.84,7.75,0,0,9-9.05,10.27-18.59C294.27,215,288.55,207,280.56,211.25Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M295.59,250.25l2,2.81c4.6,3.12,7.6-3.5,7.6-3.5l2.72-2.6a2.8,2.8,0,0,0,.15-3.63l-2.11-3.05a2.93,2.93,0,0,0-3.95-1l-2.72,1.85a5.79,5.79,0,0,0-1.87,2.12l-2,3.85A3.06,3.06,0,0,0,295.59,250.25Z",
    style: {
      fill: "#ce7a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.94,251.8l.27-5a22.73,22.73,0,0,0-.46-6,59.06,59.06,0,0,0-14.7-28,3.14,3.14,0,0,0-1.63-.9l-5.11-1.07a.39.39,0,0,0-.33.68c4.56,3.58,18.72,16.5,21.6,40.29Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.94,251.8l.27-5a22.73,22.73,0,0,0-.46-6,59.06,59.06,0,0,0-14.7-28,3.14,3.14,0,0,0-1.63-.9l-5.11-1.07a.39.39,0,0,0-.33.68c4.56,3.58,18.72,16.5,21.6,40.29Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.45,250.25l-2,2.81c-4.61,3.12-7.6-3.5-7.6-3.5l-2.72-2.6a2.8,2.8,0,0,1-.15-3.63l2.11-3.05a2.93,2.93,0,0,1,3.95-1l2.72,1.85a5.79,5.79,0,0,1,1.87,2.12l2,3.85A3.06,3.06,0,0,1,348.45,250.25Z",
    style: {
      fill: "#ce7a63"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M369.8,189.78s-14.56-1.58-9.72,8.26c0,0-11.21,2-3.18,11.54,0,0-10.37,6.91-2.32,11.31,0,0-7,14.15,7.05,8.91,0,0,6.25,10.51,14.73,1,0,0,13.7,8.5,14.2-1,0,0,11.12-1.19.77-10.49,0,0,4.33-3-.68-9.73,0,0,5.83-3.93-2-9,0,0,5.68-6-3.13-9,0,0,1.67-7.28-7.45-3.41C378.1,188.14,377,181.15,369.8,189.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.6,247.06c-5.07,3.38-6.58,9.15-6.11,14.94.08,1.09,1.79,1.12,1.7,0-.41-5.13.7-10.45,5.25-13.49.9-.61.07-2.1-.84-1.48Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M352.6,247.06c-5.07,3.38-6.58,9.15-6.11,14.94.08,1.09,1.79,1.12,1.7,0-.41-5.13.7-10.45,5.25-13.49.9-.61.07-2.1-.84-1.48Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M364.25,227.2l13,.18A10.49,10.49,0,0,1,387.58,237V237a236.44,236.44,0,0,1-.39,29.28c0,.29-.06.65-.12,1.05a10.42,10.42,0,0,1-10.47,9l-18.19-.25a10.34,10.34,0,0,1-9.76-7.12c0-.18-.1-.34-.13-.49-.79-3.69-1-11.52.2-15.11.66-2,4.25-4.84,4.9-6.84,1-3.09-1.11-10,.18-13a14.51,14.51,0,0,1,3.35-3.75A10.48,10.48,0,0,1,364.25,227.2Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.25,227.2l13,.18A10.49,10.49,0,0,1,387.58,237V237a236.44,236.44,0,0,1-.39,29.28c0,.29-.06.65-.12,1.05a10.42,10.42,0,0,1-10.47,9l-18.19-.25a10.34,10.34,0,0,1-9.76-7.12c0-.18-.1-.34-.13-.49-.79-3.69-1-11.52.2-15.11.66-2,4.25-4.84,4.9-6.84,1-3.09-1.11-10,.18-13a14.51,14.51,0,0,1,3.35-3.75A10.48,10.48,0,0,1,364.25,227.2Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.05,229.37a1.7,1.7,0,0,0-.59-.51,9.51,9.51,0,0,0-1.31,1,14.51,14.51,0,0,0-3.35,3.75c-1.29,3,.84,9.92-.18,13-.65,2-4.24,4.84-4.9,6.84-1.17,3.59-1,11.42-.2,15.11,0,.15.08.31.13.49a10.29,10.29,0,0,0,8.06,7,3.54,3.54,0,0,0,1-.63C359.22,273.84,361,232.29,359.05,229.37Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.05,229.37a1.7,1.7,0,0,0-.59-.51,9.51,9.51,0,0,0-1.31,1,14.51,14.51,0,0,0-3.35,3.75c-1.29,3,.84,9.92-.18,13-.65,2-4.24,4.84-4.9,6.84-1.17,3.59-1,11.42-.2,15.11,0,.15.08.31.13.49a10.29,10.29,0,0,0,8.06,7,3.54,3.54,0,0,0,1-.63C359.22,273.84,361,232.29,359.05,229.37Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.92,259.16a42.92,42.92,0,0,0,.6,9.39c0,.15.08.31.13.49a10.29,10.29,0,0,0,8.06,7,3.54,3.54,0,0,0,1-.63c.61-.61,1.26-7.55,1.7-15.87C354.58,261.31,349.67,259.82,347.92,259.16Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.12 403.75 379.46 403.75 382.06 389.06 375.72 389.06 373.12 403.75",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380,403h-7.12a.51.51,0,0,0-.51.44l-.81,5.63a1,1,0,0,0,1,1.13c2.48,0,3.68-.19,6.81-.19,1.93,0,7.46.2,10.13.2s2.8-2.63,1.69-2.87c-5-1.07-8.47-2.54-10.15-4A1.67,1.67,0,0,0,380,403Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "382.06 389.07 380.72 396.64 374.38 396.64 375.71 389.07 382.06 389.07"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M390.46,261s5,48.85,4.58,68.18c-.43,20.12-12.94,66-12.94,66h-8.58s6.5-44.7,5.74-64.45c-.82-21.54-7.66-69.72-7.66-69.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.78 395.48 382.84 395.48 383.58 392.27 372.31 391.88 372.78 395.48",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.35,273.15c6.32,12.73,1.27,35.94-1,44.58-1.15-13-3.08-28.83-4.59-40.47C374.75,270.67,376.43,267.29,379.35,273.15Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.86 347.03 320 353 334.61 350.25 332.47 344.28 317.86 347.03",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.73,353.2l-.5-7.11a.6.6,0,0,0-.47-.53L315,344.41a.89.89,0,0,0-1.07.95c.22,2.48.45,3.68.67,6.81.13,1.92.32,7.43.5,10.09s2.85,2.95,3,1.86c.73-4.9,2-8.3,3.27-9.89A1.53,1.53,0,0,0,321.73,353.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "334.61 350.25 327.08 351.67 324.94 345.7 332.47 344.27 334.61 350.25"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M383.33,261s-7,50.41-11.8,69.37c-5,19.73-41.94,21.41-41.94,21.41l-3.77-7.7s21.59-5.75,30.92-18.73c2.41-12.73,2.39-33.3,3.84-47.75a68.55,68.55,0,0,1,2.31-11.93,25.7,25.7,0,0,1,2.36-5.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325.39 343.36 328.69 352.87 332.1 352.9 328.79 342.18 325.39 343.36",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.78,355.5a2.57,2.57,0,0,0,.5,1.56,1,1,0,0,0,.75.32.45.45,0,0,0,.39-.23c.37-.75-1.11-3.35-1.28-3.65a.19.19,0,0,0-.16-.09.14.14,0,0,0-.12.12A10.24,10.24,0,0,0,320.78,355.5Zm1.4,1.21a.72.72,0,0,1,0,.28.18.18,0,0,1-.16.09.6.6,0,0,1-.49-.21,4.11,4.11,0,0,1-.37-2.83A9.34,9.34,0,0,1,322.18,356.71Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.86,353.56s0,0,0,.06c.4.77,1.88,2.35,2.59,2.27.17,0,.38-.12.39-.54a1.2,1.2,0,0,0-.32-.84,4.78,4.78,0,0,0-2.52-1.09.12.12,0,0,0-.13.05A.14.14,0,0,0,320.86,353.56Zm2.7,1.66v.09c0,.27-.12.28-.16.28-.42.05-1.58-1-2.1-1.83a4.07,4.07,0,0,1,2,.93A.89.89,0,0,1,323.56,355.22Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.33,404.12a2.35,2.35,0,0,0,1.54-.39.81.81,0,0,0,.27-.73.46.46,0,0,0-.25-.4c-.78-.42-3.31.87-3.59,1a.14.14,0,0,0-.08.15.16.16,0,0,0,.12.13A11.41,11.41,0,0,0,382.33,404.12Zm1.13-1.31a.55.55,0,0,1,.28.06.17.17,0,0,1,.1.16.55.55,0,0,1-.17.48c-.39.34-1.43.41-2.83.17A8.07,8.07,0,0,1,383.46,402.81Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.37,403.9h.06c.75-.35,2.25-1.71,2.13-2.43,0-.17-.15-.38-.56-.43a1.09,1.09,0,0,0-.83.26,4.19,4.19,0,0,0-.95,2.45.14.14,0,0,0,.06.13Zm1.51-2.57H382c.27,0,.29.14.3.18.07.43-.95,1.5-1.72,2a3.49,3.49,0,0,1,.81-2A.8.8,0,0,1,381.88,401.33Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.27,231.12c0,.73-.06,1.62-.08,2.44s0,1.69,0,2.53c0,1.69.06,3.39.17,5.07a76.6,76.6,0,0,0,1.18,10l.26,1.22.13.6c0,.14,0,.09,0,.13s-.06.11.23.34a8.12,8.12,0,0,0,3.61.91,51.16,51.16,0,0,0,9.93-.55l1.11,3.67a35.67,35.67,0,0,1-11,2.86,13.3,13.3,0,0,1-6.76-1,7.75,7.75,0,0,1-1.92-1.3A7.16,7.16,0,0,1,391.6,256c-.08-.19-.17-.39-.25-.59l-.1-.29-.08-.25-.2-.68-.39-1.37a65.61,65.61,0,0,1-1.92-11c-.16-1.85-.27-3.7-.28-5.56,0-.93,0-1.85,0-2.79s.07-1.83.16-2.87Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.34,254.17l5-1.72-2,6.12s-4,.73-5.65-1.33l.22-.58A4.1,4.1,0,0,1,410.34,254.17Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.95 253.22 419.04 258.55 413.26 258.57 415.3 252.45 419.95 253.22",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.71,223.55c2.48,1.06,2.67,12,2.67,12l-7.86,3.76s-5.19-11.77-2.77-14.3S391.08,222,394.71,223.55Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.71,223.55c2.48,1.06,2.67,12,2.67,12l-7.86,3.76s-5.19-11.77-2.77-14.3S391.08,222,394.71,223.55Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.98 225.66 394.94 236.64 390.65 238.98 393.98 225.66",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.17,225.57c.28,3.92-.11,13.26-3.71,35.43H364.7c.42-10.05-.19-15-4.66-34.36A3,3,0,0,1,362,223.1a34.28,34.28,0,0,1,9.1-2,83,83,0,0,1,11.7,0c3.05.28,6.35.82,8.47,1.2A3.57,3.57,0,0,1,394.17,225.57Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.07,221.1c-.78,0-1.57.13-2.36.25-.33,1.11-.64,4.09,3.89,7.45,0,0,1.58-3.61,9.83-.77,0,0,3.34-3.19,5.28-.69a8,8,0,0,0-2.87-6c-.69-.09-1.39-.16-2.07-.23A83,83,0,0,0,371.07,221.1Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.08,221.11a78.56,78.56,0,0,1,11.69,0l.76.07c.94,1.77,1.17,2.17-1.06,6.16,0,0-10.26-1.81-12.93-6.13C370,221.16,370.56,221.13,371.08,221.11Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.23,207.94c.74,3.76,1.48,10.65-1.16,13.16,0,0,1,3.82,8,3.82,7.69,0,3.68-3.82,3.68-3.82-4.2-1-4.09-4.11-3.36-7Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.16,210.44l4.25,3.62a11.77,11.77,0,0,0-.36,2.08c-1.61-.23-3.81-2-4-3.67A5.64,5.64,0,0,1,375.16,210.44Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.17,201.42c1.44,6.12,1.92,8.75,5.58,11.39,5.52,4,12.74.88,13.16-5.55.38-5.79-2-14.84-8.51-16.27A8.59,8.59,0,0,0,368.17,201.42Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.46,189.78c2.49.43,5.65,4.13,6.31,5.63-3.73-.68-14,2.5-14,2.5s-4.6-.52-2-4.07S378.46,189.78,378.46,189.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379,201.38c.08.5.42.87.75.81s.53-.51.44-1-.42-.87-.75-.82S378.86,200.87,379,201.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.4,200.41c.08.5.42.87.75.81s.53-.51.44-1-.42-.86-.75-.81S384.31,199.9,384.4,200.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.7,199.45l1.15-.56S385.39,199.94,384.7,199.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.93,201.62a13.66,13.66,0,0,0,2.34,2.91,2.21,2.21,0,0,1-1.74.64Z",
    style: {
      fill: "#ed893e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.12,208.11a4,4,0,0,0,.75-.07.15.15,0,1,0-.05-.29,4.06,4.06,0,0,1-3.52-1,.15.15,0,0,0-.21,0,.15.15,0,0,0,0,.21A4.17,4.17,0,0,0,382.12,208.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.84,200.61a.31.31,0,0,0,.29-.21,3.57,3.57,0,0,1,2.12-1.91.29.29,0,0,0,.19-.37.3.3,0,0,0-.38-.2,4.14,4.14,0,0,0-2.51,2.3.29.29,0,0,0,.2.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.21,198.16a.31.31,0,0,0,.27-.11.29.29,0,0,0-.05-.42,3,3,0,0,0-2.67-.59.3.3,0,0,0,.19.57h0a2.4,2.4,0,0,1,2.11.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.25,200.42l1.15-.56S379.94,200.91,379.25,200.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.56,239.21l-4-9.06s3.08,4.24,4.17,2.6c.91-1.37-3.35-3.38-4.72-4a.8.8,0,0,0-.79.09c-1.5,1.09-6.9,5.32-4.45,7.71,2.84,2.75,4.29-6.89,4.29-6.89l-.7,10.63,1.28.5.15-10.6,3.81,10.08Zm-.41-6.86c-.46.57-2.67-2.23-2.67-2.23S387.62,231.78,387.15,232.35Zm-8.83,3.26c-1.08-1.81,3-5.23,3-5.23S379.4,237.42,378.32,235.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.72,200.3c-.32-1.69-1.67-2.87-3-2.62a2.72,2.72,0,0,0-1.94,2.95,1.61,1.61,0,0,0-1.65.3,3.12,3.12,0,0,0-6,1.51l-6.77,1.25,0,.39,6.82-1.26a3.12,3.12,0,0,0,6.1-1.33s0-.08,0-.13a1.19,1.19,0,0,1,1.56-.27s0,.08,0,.12c.31,1.7,1.67,2.87,3,2.62S389,202,388.72,200.3Zm-9,4.46a2.74,2.74,0,1,1,2.2-3.19A2.75,2.75,0,0,1,379.7,204.76Zm7.07-1.31c-1.14.21-2.3-.82-2.57-2.31s.43-2.87,1.57-3.08,2.29.83,2.57,2.31S387.91,203.24,386.77,203.45Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.71,195.89c2.22,1.7,1.25,7.87-1.51,9.76C364.9,204.62,364.08,190.81,370.71,195.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.46,207.38a4.65,4.65,0,0,0,2.8,2.13c1.56.4,2.31-1,1.84-2.46s-1.73-3.1-3.28-2.86A2.07,2.07,0,0,0,367.46,207.38Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.33,253.11l-8.58-8.57a14.44,14.44,0,0,1-4.23-10.22H397a14.44,14.44,0,0,1-4.23,10.22l-8.57,8.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.36,253.11c-3.53-.47-6.82-8.48-8.42-8.29s3.87,7,1.64,7-3.53-2.62-4.45-2.52-2.27,2.9-3.82,2.7-.53-4-1.35-4.06-2.28,4.69-4.08,4.15,3-8.12,2.05-8.41-3.15,2.75-4.95,6.23a6.73,6.73,0,0,1-3.26,3.15Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.26,242.63c-1.21-.17-2.06,3.09-.85,3.51S402.47,242.8,401.26,242.63Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.53,234.57s-.39-1.32,2.64-1.32,6.85-.3,6.85,1.32-.3,1.78.22,2.89-1.67-.08-1.92-1.49-1.58.68-1.36,2.81-1.48,2.34-1.64-.81-1.73-3.15-1.77-1.87-1.15,1.66-1.7.3,0,2.86-1,2.51S396.48,236.44,396.53,234.57Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.11,233.86c0-.18-.23-.32-.48-.43a31.41,31.41,0,0,0-5.46-.18,6.78,6.78,0,0,0-1.32.11c-.3.13-.69.36-.66.63C397.23,234.44,405.21,234.48,405.11,233.86Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.45,
    y: 252.6,
    width: 46.96,
    height: 2.85,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.45,
    y: 252.6,
    width: 46.96,
    height: 2.85,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.45,
    y: 252.6,
    width: 23.48,
    height: 2.85,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.73,222.83c3.45,2.41,13.54,12.45-4.61,39.32a3.37,3.37,0,0,0-.55,1.49l-.27,2.54a.58.58,0,0,0,1,.4c3.62-5.09,13.83-20.24,13.83-29.79s-3.39-13.5-5.54-15a3.22,3.22,0,0,0-3.09-.32l-.7.29A.62.62,0,0,0,363.73,222.83Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.73,222.83c3.45,2.41,13.54,12.45-4.61,39.32a3.37,3.37,0,0,0-.55,1.49l-.27,2.54a.58.58,0,0,0,1,.4c3.62-5.09,13.83-20.24,13.83-29.79s-3.39-13.5-5.54-15a3.22,3.22,0,0,0-3.09-.32l-.7.29A.62.62,0,0,0,363.73,222.83Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.53,253.33a32,32,0,0,1-4.8-1.37,6.7,6.7,0,0,1-1.55-.79l0-.16a64.88,64.88,0,0,1-.73-10.28c0-1.76,0-3.53.09-5.3s.17-3.58.28-5.25l-7.71-.76c-.22,2-.29,3.84-.37,5.76s0,3.8,0,5.72a56.71,56.71,0,0,0,1.54,11.62l.09.36.05.19c0,.16.09.31.14.47a5.51,5.51,0,0,0,.86,1.56,6.85,6.85,0,0,0,1.95,1.71,12.87,12.87,0,0,0,3.36,1.36,31.94,31.94,0,0,0,6,1,64.7,64.7,0,0,0,11.4-.18l0-3.83C381.56,254.62,377.94,254.07,374.53,253.33Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.47,224.82c-1.29,2.37,0,12.83,0,12.83l12.21,1.56s.78-10.44-1.75-12.86S358.94,222.12,357.47,224.82Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M357.47,224.82c-1.29,2.37,0,12.83,0,12.83l12.21,1.56s.78-10.44-1.75-12.86S358.94,222.12,357.47,224.82Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M382.57,255.54l6.11-3.11-1.47,6.28s-3.92,1.1-5.75-.8Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.91 253.46 392.4 258.65 387.21 258.71 388.68 252.43 393.91 253.46",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.06,221.86a36.36,36.36,0,0,1,6.88,20.26.19.19,0,0,0,.38,0l.9-4.21,0-.24c0-1,0-7.16-5-15.92a.36.36,0,0,0-.27-.18l-2.58-.3A.35.35,0,0,0,386.06,221.86Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.06,221.86a36.36,36.36,0,0,1,6.88,20.26.19.19,0,0,0,.38,0l.9-4.21,0-.24c0-1,0-7.16-5-15.92a.36.36,0,0,0-.27-.18l-2.58-.3A.35.35,0,0,0,386.06,221.86Z",
    style: {
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M224,240c1.09-9.83,1.58-15-2.05-20.67s-4.56-37.89-28-32.57c-5.14,1.17-12.47,2.21-9.54,18.8s-6.49,14-1,22.56-9,18.39-1.74,27.74-6.08,15.94-1.24,20.58a51.09,51.09,0,0,1,5.74-2.22c-.47-.83-.77-2.29.17-4.75,1.74-4.55,4.64-10.06,1.16-15.24,0,0,4.74,1.59,2.56,12-.71,3.42-.66,5.55-.27,6.87,1.71-.44,3.59-.85,5.58-1.17a6.41,6.41,0,0,1-.87-3.65c.26-3.8,1.91-5.35,1.71-8.4,0,0,1.75,4.41.87,7.12a5.58,5.58,0,0,0,.58,4.62,36.81,36.81,0,0,1,15.56,1.3c15.23,5,19.51-8.12,19.51-8.12S222.94,249.82,224,240Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.64,230.44l-.08.56-.08.76c0,.51-.08,1-.08,1.56a19.58,19.58,0,0,0,.19,3.16,17.74,17.74,0,0,0,3.62,8.58c.32.43.68.83,1,1.24l.56.59.5.57a13.14,13.14,0,0,0,1.8,1.72,5.23,5.23,0,0,0,.71.48,2.17,2.17,0,0,0,.38.16l.21.05.09,0a.05.05,0,0,1,0,0s0,0,0,.09a2.14,2.14,0,1,1,3.09,2.95l-.37.43c-.1.12-.2.22-.3.32a8.34,8.34,0,0,1-.65.53,6.4,6.4,0,0,1-1.48.74,7.38,7.38,0,0,1-3.17.32,11.92,11.92,0,0,1-5.05-1.94c-.34-.23-.67-.46-1-.7l-.86-.76c-.55-.52-1.11-1-1.63-1.62a25,25,0,0,1-2.8-3.72,24.46,24.46,0,0,1-3.25-8.75,25.65,25.65,0,0,1-.35-4.63,23.16,23.16,0,0,1,.15-2.34c0-.39.09-.78.16-1.18l.12-.62.07-.32.1-.42a4.29,4.29,0,0,1,8.42,1.61Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.12,248.28l-.29,1.83a2.16,2.16,0,0,1-1.17,1.59l-2.92,1.45a4,4,0,0,1-3.69-.05l-.71-.38c.28-3.07,2.83-6.19,2.83-6.19l.63-1a1.8,1.8,0,0,1,2.49-.58l1.93,1.22A2.08,2.08,0,0,1,239.12,248.28Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.15,222.26c5.85.44,8.65,4.67,11.41,14.32-2.07,3.27-10.42,5.71-10.42,5.71S212.68,228,217.15,222.26Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.15,222.26c5.85.44,8.65,4.67,11.41,14.32-2.07,3.27-10.42,5.71-10.42,5.71S212.68,228,217.15,222.26Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.05,406.49c-5.09,1.37-5.78,1.47-8.66,2.15-2.47.57-3,1-4.95,1.52-1.66.41-2-1.18-2-3.13,0-1-.12-3-.17-4.56l7.31-2.55c1.59,1.72,4.72,3.93,7.69,3.54S264.08,405.94,262.05,406.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.73,274.4c-3.94,15.38-6.46,14.67,13.52,62.06C219.56,360.31,246,402.11,246,402.11c2.54.1,7-.58,8-1.59-4.56-13.69-13.35-47.92-15.82-70.06-2.34-21.09-6.14-48.48-8.25-64.63-.22-1.61-.82-6.45-.82-6.45L211.63,264S211.37,271.87,210.73,274.4Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M210.73,274.4c-3.94,15.38-6.46,14.67,13.52,62.06C219.56,360.31,246,402.11,246,402.11c2.54.1,7-.58,8-1.59-4.56-13.69-13.35-47.92-15.82-70.06-2.34-21.09-6.14-48.48-8.25-64.63-.22-1.61-.82-6.45-.82-6.45L211.63,264S211.37,271.87,210.73,274.4Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M209.34,297.12c1.76,6.88,5.5,16.79,12.36,33.27C224.9,303.3,219,286.1,219,286.1h-8Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.7,394.55c.48,1.2,1.35,3.28,2.16,4.81a1.12,1.12,0,0,1-.1,1.42c-2.86,2-7.86,2.58-9.46,2.72a1,1,0,0,1-.85-.65l-2.22-4.43c-.3-.61-.19-1.29.22-1.44l9.23-3.17C252,393.68,252.48,394,252.7,394.55Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,394.39A53,53,0,0,1,158.6,383c-.72-2.39-1.14-2-2-4.39a2.42,2.42,0,0,1,2.46-3,21.84,21.84,0,0,0,4.11.13L167,381c-1.69,2-2.69,9.07-1,12.65C167.13,396.24,164,396.2,163,394.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220,278.87s.7,45.83-2.44,61.48c-3.08,15.3-51.39,41.67-51.39,41.67-1.08.36-3.17-5.26-3-6.49,14.53-14.15,28.46-37.63,39.41-40.87-10.8-38.66-8.63-46-1.62-59.07,1.6-3,.84-9.76.84-9.76L220.11,264Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M220,278.87s.7,45.83-2.44,61.48c-3.08,15.3-51.39,41.67-51.39,41.67-1.08.36-3.17-5.26-3-6.49,14.53-14.15,28.46-37.63,39.41-40.87-10.8-38.66-8.63-46-1.62-59.07,1.6-3,.84-9.76.84-9.76L220.11,264Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M172.05,379.08c-1.12.8-3.12,2.22-4.57,3.3-.48.36-1,.44-1.31.21-1.88-1.78-3.6-5.48-4.14-6.71-.1-.24.06-.61.41-.91l3.78-3.22c.52-.44,1.22-.56,1.45-.25l4.88,6.5C172.75,378.27,172.54,378.74,172.05,379.08Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,232a84.7,84.7,0,0,1,1.86,11.45c.67,5.61,1.16,11.16,1.8,20.43l-28.08,4.45c-.69-8-3-16.87-10.9-33.87A6.63,6.63,0,0,1,195,225c1.09-.29,2.26-.57,3.46-.82a91.94,91.94,0,0,1,12.75-2c1.4-.09,2.87-.14,4.27-.17C220.51,221.94,225.09,227.06,226,232Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197,209.72c1.76,3.93,4.31,11.23,2.08,14.39,0,0,3.79-1.2,12.85,2.6,1.85-3.8-.1-4.62-.1-4.62-4.83-.35-5.5-3.72-5.45-7Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.07,226c-2.65.81-2.85,5-2.85,5s-7.26-3.58-9.85-6.51a27.25,27.25,0,0,0,2.15-1.89S208.24,224.64,210.07,226Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.59,225.11s2.44.26,3.82,3.43c-.33-6.08-3.28-6.66-3.28-6.66a3.54,3.54,0,0,0-2.52,0A2.94,2.94,0,0,1,212.59,225.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.86,211.91l5.56,3.18a12.58,12.58,0,0,0,.13,2.3c-1.8,0-4.65-1.49-5.26-3.27A6.38,6.38,0,0,1,200.86,211.91Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.59,202.09c2.26,6.32,3.08,9,7.29,11.57,6.33,3.81,13.61.11,13.29-6.64-.28-6.08-3.92-15.39-11-16.48A8.59,8.59,0,0,0,192.59,202.09Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.36,201.48a16.4,16.4,0,0,0,3,3,2.25,2.25,0,0,1-1.79.81Z",
    style: {
      fill: "#a02724"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.62,208.45a5.22,5.22,0,0,0,.91-.18.15.15,0,0,0,.1-.2.18.18,0,0,0-.21-.11,4.61,4.61,0,0,1-4-.68.17.17,0,0,0-.23,0,.16.16,0,0,0,0,.23A4.94,4.94,0,0,0,205.62,208.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.58,202.25c.19.53.63.88,1,.79s.47-.61.28-1.14-.62-.88-1-.79S201.39,201.72,201.58,202.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.23,200.15c.19.53.63.88,1,.78s.47-.61.28-1.14-.62-.88-1-.78S208,199.62,208.23,200.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.37,199.08l1.14-.72S209.21,199.53,208.37,199.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.68,199.42a.26.26,0,0,0,.16-.18,2.45,2.45,0,0,1,1.57-1.67.3.3,0,0,0,.21-.39.34.34,0,0,0-.42-.22,3,3,0,0,0-2,2.08.33.33,0,0,0,.23.4A.35.35,0,0,0,199.68,199.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.76,196.61a.3.3,0,0,0,.22-.1.33.33,0,0,0,0-.46,3.46,3.46,0,0,0-2.93-.86.3.3,0,0,0-.21.39.35.35,0,0,0,.41.24,2.79,2.79,0,0,1,2.32.71A.32.32,0,0,0,209.76,196.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.72,201.19l1.14-.73S202.56,201.64,201.72,201.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.85,191.42a7.46,7.46,0,0,1,2.71,3,6.42,6.42,0,0,1,2.07-.51,6,6,0,0,0-3.57-2.78,6.44,6.44,0,0,1,5,2.82,10.38,10.38,0,0,1,3.59,1.22s-6.36-10.37-15.1-5.72-1.94,17.13-1.94,17.13h1.74s4-.18-.4-8.33c0,0,3.06,1.09,3.23,3.44,0,0,1.13-4.37,4.2-6.57A7.8,7.8,0,0,0,199.85,191.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.44,205.54s-10.41-8.88,1.89-17.32c0,0-9.39-.19-9.2-8.61l11.13,6.72,7.22-10.21s4,5.52-5.1,11.23c0,0,4.56-1.93,8.07,2.82,0,0-5.49-3.43-10.66-.27C186.29,195.71,192.44,205.54,192.44,205.54Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.62,208.17a5.49,5.49,0,0,0,3.84,1.67c1.85,0,2.15-1.92,1.11-3.52-.94-1.43-3-3.15-4.65-2.37S190.33,206.86,191.62,208.17Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,236.48l-5.53-8.2s3.79,3.61,4.57,1.81c.65-1.52-3.9-2.72-5.37-3.07a.81.81,0,0,0-.76.23c-1.27,1.35-5.82,6.49-3,8.39,3.29,2.19,3-7.55,3-7.55l1.23,10.58,1.35.26-1.77-10.46,5.58,9.23Zm-1.64-6.68c-.35.64-3-1.71-3-1.71S217.75,229.15,217.39,229.8Zm-8.1,4.8c-1.39-1.58,2-5.67,2-5.67S210.68,236.18,209.29,234.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.22,236.66H219.54v6.81h32.69A26.76,26.76,0,0,1,252.22,236.66Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.22,236.66H219.54v6.81h32.69A26.76,26.76,0,0,1,252.22,236.66Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.49,243.83H215.22l-.1-.1a5.23,5.23,0,0,1,0-7.41l.1-.1h10.27l-.61.61a4.53,4.53,0,0,0,0,6.39Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M225.49,243.83H215.22l-.1-.1a5.23,5.23,0,0,1,0-7.41l.1-.1h10.27l-.61.61a4.53,4.53,0,0,0,0,6.39Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M252.55,243.83H224.81l0,0a5.32,5.32,0,0,1-1.6-3.59,5.18,5.18,0,0,1,1.53-3.89l.1-.1h27.74a.36.36,0,0,1,.36.35h0a.36.36,0,0,1-.36.36H225.11a4.54,4.54,0,0,0,0,6.19h27.44a.36.36,0,0,1,.36.35h0A.36.36,0,0,1,252.55,243.83Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,222.9H220.59V229H250A23.81,23.81,0,0,1,250,222.9Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,222.9H220.59V229H250A23.81,23.81,0,0,1,250,222.9Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,229.36H216.7l-.09-.09a4.72,4.72,0,0,1,0-6.67l.09-.1H226l-.55.55a4.06,4.06,0,0,0,0,5.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.3,229.36h-25l0,0a4.83,4.83,0,0,1-1.45-3.23,4.71,4.71,0,0,1,1.38-3.5l.09-.1h25a.32.32,0,0,1,.32.33h0a.32.32,0,0,1-.32.32H225.6a4.06,4.06,0,0,0,0,5.56h24.7a.32.32,0,0,1,.32.33h0A.32.32,0,0,1,250.3,229.36Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.3,229.36h-25l0,0a4.83,4.83,0,0,1-1.45-3.23,4.71,4.71,0,0,1,1.38-3.5l.09-.1h25a.32.32,0,0,1,.32.33h0a.32.32,0,0,1-.32.32H225.6a4.06,4.06,0,0,0,0,5.56h24.7a.32.32,0,0,1,.32.33h0A.32.32,0,0,1,250.3,229.36Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M250,216.05H220.59v6.13H250A23.73,23.73,0,0,1,250,216.05Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,216.05H220.59v6.13H250A23.73,23.73,0,0,1,250,216.05Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,222.5H216.7l-.09-.09a4.72,4.72,0,0,1,0-6.67l.09-.09H226l-.55.55a4,4,0,0,0,0,5.75Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226,222.5H216.7l-.09-.09a4.72,4.72,0,0,1,0-6.67l.09-.09H226l-.55.55a4,4,0,0,0,0,5.75Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M250.3,222.5h-25l0,0a4.88,4.88,0,0,1-1.45-3.24,4.71,4.71,0,0,1,1.38-3.5l.09-.09h25a.32.32,0,0,1,.32.32h0a.32.32,0,0,1-.32.32H225.6a4.08,4.08,0,0,0,0,5.57h24.7a.32.32,0,0,1,.32.32h0A.32.32,0,0,1,250.3,222.5Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.3,222.5h-25l0,0a4.88,4.88,0,0,1-1.45-3.24,4.71,4.71,0,0,1,1.38-3.5l.09-.09h25a.32.32,0,0,1,.32.32h0a.32.32,0,0,1-.32.32H225.6a4.08,4.08,0,0,0,0,5.57h24.7a.32.32,0,0,1,.32.32h0A.32.32,0,0,1,250.3,222.5Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M250,244.27H220.59v6.14H250A23.81,23.81,0,0,1,250,244.27Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,244.27H220.59v6.14H250A23.81,23.81,0,0,1,250,244.27Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,250.73H216.7l-.09-.09a4.72,4.72,0,0,1,0-6.67l.09-.1H226l-.55.56a4,4,0,0,0,0,5.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.3,250.73h-25l0,0a4.83,4.83,0,0,1-1.45-3.23,4.71,4.71,0,0,1,1.38-3.5l.09-.1h25a.32.32,0,0,1,.32.33h0a.32.32,0,0,1-.32.32H225.6a4.08,4.08,0,0,0,0,5.57h24.7a.32.32,0,0,1,.32.32h0A.32.32,0,0,1,250.3,250.73Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,229.76H220.59v6.13H250A23.73,23.73,0,0,1,250,229.76Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,229.76H220.59v6.13H250A23.73,23.73,0,0,1,250,229.76Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,236.22H216.7l-.09-.1a4.72,4.72,0,0,1,0-6.67l.09-.09H226l-.55.55a4,4,0,0,0,0,5.75Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226,236.22H216.7l-.09-.1a4.72,4.72,0,0,1,0-6.67l.09-.09H226l-.55.55a4,4,0,0,0,0,5.75Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M250.3,236.22h-25l0,0a4.83,4.83,0,0,1-1.45-3.23,4.72,4.72,0,0,1,1.38-3.51l.09-.09h25a.32.32,0,0,1,.32.32h0a.32.32,0,0,1-.32.33H225.6a4.06,4.06,0,0,0,0,5.56h24.7a.32.32,0,0,1,.32.32h0A.32.32,0,0,1,250.3,236.22Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.3,236.22h-25l0,0a4.83,4.83,0,0,1-1.45-3.23,4.72,4.72,0,0,1,1.38-3.51l.09-.09h25a.32.32,0,0,1,.32.32h0a.32.32,0,0,1-.32.33H225.6a4.06,4.06,0,0,0,0,5.56h24.7a.32.32,0,0,1,.32.32h0A.32.32,0,0,1,250.3,236.22Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M229.77,244.55l-2.07-.46a2.47,2.47,0,0,0-2.19.58l-2.77,2.49a4.6,4.6,0,0,0-1.49,4l.1.92c3.39,1,7.78-.42,7.78-.42l1.29-.26a2.06,2.06,0,0,0,1.67-2.4l-.49-2.57A2.38,2.38,0,0,0,229.77,244.55Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.18,248.09a2.14,2.14,0,0,0-3-.68l-.05,0c-1.64,1-3.33,2.12-5,3.11s-3.37,2-5.06,2.87a34.51,34.51,0,0,1-5,2.23,9.39,9.39,0,0,1-1.82.45c-.72-1.16-1.42-2.36-2.06-3.61-.77-1.58-1.5-3.19-2.17-4.85s-1.28-3.34-1.85-5c-.29-.86-.57-1.71-.83-2.57s-.52-1.76-.73-2.51l0-.13a4.31,4.31,0,0,0-8.34,2.13c.26,1.1.5,2,.8,3s.6,1.93.92,2.88c.66,1.89,1.4,3.77,2.23,5.61a57.34,57.34,0,0,0,2.81,5.45,45,45,0,0,0,3.57,5.17l.12.14a2.79,2.79,0,0,0,.45.46,6.41,6.41,0,0,0,3.34,1.43,8.14,8.14,0,0,0,2.61-.09,15.37,15.37,0,0,0,3.71-1.23,36,36,0,0,0,5.68-3.4c1.72-1.24,3.35-2.55,4.91-3.92s3.05-2.77,4.5-4.31A2.14,2.14,0,0,0,226.18,248.09Z",
    style: {
      fill: "#b55b52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.79,226c-4.8,3.39-5,8.46-2.44,18.16,3.46,1.73,11.88-.46,11.88-.46S199.58,228.68,192.79,226Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.79,226c-4.8,3.39-5,8.46-2.44,18.16,3.46,1.73,11.88-.46,11.88-.46S199.58,228.68,192.79,226Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-36"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M173.61,217.46c-1.74,4.29-3.55,8.58-5.36,12.85s-3.66,8.55-5.3,12.72l-.11.28a1.09,1.09,0,0,0-.05.14,2.58,2.58,0,0,0-.1.4,7.26,7.26,0,0,0-.08,1.12,16.58,16.58,0,0,0,.29,2.84,47.65,47.65,0,0,0,1.67,6.25c.69,2.12,1.5,4.24,2.34,6.36s1.75,4.25,2.65,6.31l-3.74,2.21a79.73,79.73,0,0,1-7.38-12.42,45.16,45.16,0,0,1-2.7-7,23.3,23.3,0,0,1-.79-4.07,13.32,13.32,0,0,1,0-2.37,10.84,10.84,0,0,1,.18-1.33c0-.24.1-.47.17-.71l.17-.55c.72-2.34,1.48-4.57,2.28-6.79s1.62-4.43,2.47-6.62c1.68-4.39,3.46-8.71,5.35-13Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.07,265.66l3.5,2.92a4.11,4.11,0,0,1,.33,6h0a4.12,4.12,0,0,1-6.94-1.72,20.5,20.5,0,0,1-.84-4.68Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.75,266.19a22.58,22.58,0,0,0-4.55,2.39.43.43,0,0,1-.56-.06,10.81,10.81,0,0,1-2.3-3.58.39.39,0,0,1,.14-.38c1.41-1.12,5.06-3,5.82-2.38s1.4,2.58,1.71,3.48A.41.41,0,0,1,169.75,266.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,227.3c-7.37,3.84-10.28,11.43-10.51,19.36,0,1.48,2.27,1.78,2.31.28.2-7,2.5-14.06,9.12-17.5,1.31-.69.41-2.83-.92-2.14Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M120,227.3c-7.37,3.84-10.28,11.43-10.51,19.36,0,1.48,2.27,1.78,2.31.28.2-7,2.5-14.06,9.12-17.5,1.31-.69.41-2.83-.92-2.14Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M138.71,202.12l17.61,2.16a14.3,14.3,0,0,1,12.57,14.54v.1c-.33,10-2.92,29.85-4.88,39.64-.08.39-.19.87-.32,1.41a14.22,14.22,0,0,1-15.54,10.69l-24.63-3a14.1,14.1,0,0,1-12.16-11.11c0-.25-.09-.48-.11-.68-.53-5.12.39-15.76,2.52-20.45,1.18-2.62,6.47-5.94,7.66-8.56,1.83-4,0-13.75,2.16-17.61.73-1.28,3-3.06,5.1-4.59A14.28,14.28,0,0,1,138.71,202.12Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.71,202.12l17.61,2.16a14.3,14.3,0,0,1,12.57,14.54v.1c-.33,10-2.92,29.85-4.88,39.64-.08.39-.19.87-.32,1.41a14.22,14.22,0,0,1-15.54,10.69l-24.63-3a14.1,14.1,0,0,1-12.16-11.11c0-.25-.09-.48-.11-.68-.53-5.12.39-15.76,2.52-20.45,1.18-2.62,6.47-5.94,7.66-8.56,1.83-4,0-13.75,2.16-17.61.73-1.28,3-3.06,5.1-4.59A14.28,14.28,0,0,1,138.71,202.12Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.34,204.28a2.68,2.68,0,0,0-.72-.78,15,15,0,0,0-1.93,1.13c-2.15,1.53-4.37,3.31-5.1,4.59-2.18,3.86-.33,13.58-2.16,17.61-1.19,2.62-6.48,5.94-7.66,8.56-2.13,4.69-3,15.33-2.52,20.45,0,.2.06.43.11.68a14,14,0,0,0,9.88,10.63,4.87,4.87,0,0,0,1.41-.7C125,264.59,133.56,208.53,131.34,204.28Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.34,204.28a2.68,2.68,0,0,0-.72-.78,15,15,0,0,0-1.93,1.13c-2.15,1.53-4.37,3.31-5.1,4.59-2.18,3.86-.33,13.58-2.16,17.61-1.19,2.62-6.48,5.94-7.66,8.56-2.13,4.69-3,15.33-2.52,20.45,0,.2.06.43.11.68a14,14,0,0,0,9.88,10.63,4.87,4.87,0,0,0,1.41-.7C125,264.59,133.56,208.53,131.34,204.28Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.83,243a58,58,0,0,0-.58,12.82c0,.2.06.43.11.68a14,14,0,0,0,9.88,10.63,4.87,4.87,0,0,0,1.41-.7c.92-.74,2.84-10.05,4.67-21.27C120.54,246.93,114.1,244.18,111.83,243Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.38,220.39c2.78-8.34-1.53-14.74-8-11.69-5.84,2.74-13.07,32.64-12.08,37.54,1.52,7.45,7.53,17.46,7.53,17.46l6.12-2.94s-5.09-11.59-4.58-16S171.74,228.3,174.38,220.39Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.38,220.39c2.78-8.34-1.53-14.74-8-11.69-5.84,2.74-13.07,32.64-12.08,37.54,1.52,7.45,7.53,17.46,7.53,17.46l6.12-2.94s-5.09-11.59-4.58-16S171.74,228.3,174.38,220.39Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.73,207.94s5.44,21.18-6.63,57.92l-35.82-4.34c.42-5.53,7.13-31.93,5-58.48a95.64,95.64,0,0,1,12.17-.06,134.57,134.57,0,0,1,15.22,1.85A67.91,67.91,0,0,1,169.73,207.94Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,186c.37,5,.23,14.1-3.59,16.95a44.88,44.88,0,0,1,7.52,5.48,4.58,4.58,0,0,0,7.63-2.7,7.28,7.28,0,0,0,.07-.93c-5.3-2-4.67-6-3.25-9.69Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.43,189.74l5,5.4a16.24,16.24,0,0,0-.79,2.64c-2-.55-4.64-3.19-4.6-5.41A7.61,7.61,0,0,1,151.43,189.74Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.33,178.58c-.4,6.69-1,10.58,2,14.39,4.42,5.73,13,3.69,15.36-2.74,2.15-5.79,2.44-15.74-3.74-19.17A9.13,9.13,0,0,0,148.33,178.58Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.17,181.66c-.07.54.17,1,.52,1.05s.69-.36.76-.9-.17-1-.52-1.05S158.23,181.12,158.17,181.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.27,182.4c-.06.54.17,1,.52,1.06s.7-.36.76-.9-.17-1-.52-1.06S164.34,181.86,164.27,182.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.3,182.43a19.51,19.51,0,0,0,2,4.94,3.16,3.16,0,0,1-2.64.17Z",
    style: {
      fill: "#ed893e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.94,188.84a.16.16,0,0,0,.16-.14.16.16,0,0,0-.14-.18,4.29,4.29,0,0,1-3.28-2.1.16.16,0,0,0-.22-.07.16.16,0,0,0-.07.21,4.56,4.56,0,0,0,3.53,2.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.61,179.47a.32.32,0,0,0,.23-.1,2.53,2.53,0,0,1,2.16-.81.32.32,0,0,0,.37-.26.32.32,0,0,0-.25-.37,3.18,3.18,0,0,0-2.74,1,.32.32,0,0,0,0,.45A.35.35,0,0,0,156.61,179.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.24,180.63l.1,0a.31.31,0,0,0,.2-.4,3.22,3.22,0,0,0-2.06-2.07.33.33,0,0,0-.39.24.31.31,0,0,0,.23.38,2.56,2.56,0,0,1,1.62,1.65A.31.31,0,0,0,167.24,180.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.33,265.77s13.52,42.43,15,63c1.56,21.36,6.76,75.34,6.76,75.34l-5.24,1.58s-17.79-49.71-18.49-70.72c-.45-13.74-25.08-72.43-25.08-72.43Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.58,399.64l-6.89,3.14a.59.59,0,0,0-.33.66l1.27,6a1,1,0,0,0,1.4.68c2.39-1.14,3.49-1.82,6.52-3.2,1.87-.85,8.51-3.65,11.08-4.82s1.75-3.88.59-3.63c-5.2,1.13-10.34,1.75-12.47,1.08A1.63,1.63,0,0,0,184.58,399.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.18,398.15l-.06-.14a.53.53,0,0,0-.47-.31c-.83,0-2.18,1.94-2.44,2.33a.17.17,0,0,0,0,.21.16.16,0,0,0,.19.08c.87-.17,2.38-.57,2.77-1.38A1,1,0,0,0,188.18,398.15Zm-2.39,1.7c.61-.85,1.45-1.79,1.85-1.77,0,0,.09,0,.14.11a.63.63,0,0,1,0,.59C187.62,399.2,186.88,399.58,185.79,399.85Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.24,397.19a.61.61,0,0,0-.07-.14.56.56,0,0,0-.67-.18.92.92,0,0,0-.56.48c-.45.92.22,2.77.25,2.85a.17.17,0,0,0,.15.12.19.19,0,0,0,.18-.07A4.52,4.52,0,0,0,186.24,397.19Zm-.82,2.49a3.69,3.69,0,0,1-.14-2.16.58.58,0,0,1,.33-.29c.18-.05.22,0,.25,0C186.1,397.61,185.8,398.92,185.42,399.68Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.88,262.63l28.22,3.23s12.77,43.48,15.1,57.58c2.07,12.55,5.13,58.17,5.77,68a2.48,2.48,0,0,1-1.64,2.51l-5.54,2a2.5,2.5,0,0,1-3.24-1.61c-2.92-9.56-13.2-43.74-13.86-54.67C158.92,326.91,134.88,262.63,134.88,262.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.11,280.43c.26,1.42.53,2.84.79,4.25,1.29,3.65,2.66,7.53,4,11.51,2.89-7.54,2.58-17.77,2-22.26C148.4,270.22,144.55,276.19,142.11,280.43Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.79 406.21 185.17 403.43 186.72 402.85 186.32 405.64 184.79 406.21",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "187.36 405.24 187.88 401.75 189.56 401.04 188.98 404.53 187.36 405.24",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.24,264.67S133,319.05,123,336.71c-10.71,18.81-55.36-15.88-55.36-15.88l4-4.2S97.77,328,108.12,327.17c10.18-19,19.16-65.65,19.16-65.65Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.89,264.75l-26.61-3.23s-11.81,46-17.14,58.6c-2.86,6.76-13.36,6-31.27-1.16l-5.06,7.44s28.94,20.43,42.68,16.94S153.89,264.75,153.89,264.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.14,322.31l5.8-4.88a.58.58,0,0,0,.14-.72l-2.85-5.44a1,1,0,0,0-1.52-.28c-2,1.74-2.88,2.68-5.43,4.83-1.57,1.32-7.21,5.8-9.38,7.62s-.64,4.2.41,3.65C59,324.61,63.8,322.63,66,322.7A1.6,1.6,0,0,0,67.14,322.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.07,324.71l.1.12a.56.56,0,0,0,.53.18c.82-.19,1.59-2.46,1.73-2.91a.17.17,0,0,0-.05-.2.2.2,0,0,0-.21,0c-.79.4-2.14,1.19-2.3,2.08A1,1,0,0,0,64.07,324.71Zm1.85-2.28c-.36,1-.92,2.12-1.3,2.21a.16.16,0,0,1-.17-.07.61.61,0,0,1-.2-.56C64.33,323.56,64.94,323,65.92,322.43Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2,325.11a.43.43,0,0,0,.11.12.55.55,0,0,0,.69,0,.92.92,0,0,0,.41-.61c.18-1-1-2.61-1-2.68a.18.18,0,0,0-.18-.08.19.19,0,0,0-.15.12A4.46,4.46,0,0,0,66.2,325.11Zm.12-2.62a3.68,3.68,0,0,1,.71,2.05.58.58,0,0,1-.23.37c-.16.1-.22,0-.25,0A3.77,3.77,0,0,1,66.32,322.49Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.81,296.94c4-14.33,8.05-29.28,9.53-34.81l-1.55-.19c-1.52,5.69-5.49,20.44-9.47,34.58l-.43,1.56c-4,14.19-8.11,28.87-13.16,30.54-9.62,3.18-24.26-3.41-30.8-6.81L76,323.12c5.38,2.83,16.35,7.9,25.85,7.9a20.2,20.2,0,0,0,6.33-.93c5.83-1.92,9.69-15.67,14.16-31.59Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.68 314.92 67.13 317.69 65.83 318.7 65.38 315.92 66.68 314.92",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "64.5 316.61 65.04 320.09 63.65 321.26 63.17 317.76 64.5 316.61",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.73,202.48s26.65,8,28.65,11.62l2.11-1.94s-6.85-4.35-23.4-9.68C142.09,202.48,134.73,200.84,134.73,202.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.68,223.49s-12.23,17.42-35.93,30.26a7.15,7.15,0,0,0-3.42,4.17l-.12.38a1.07,1.07,0,0,0,1.46,1.3c5.55-2.5,21.37-11.05,40.5-34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,209.75c2.75,3.11,5.62,6.27,8.49,9.3,1.42,1.53,2.89,3,4.35,4.45s3,2.81,4.42,4c.37.29.73.55,1.08.8l.5.34.22.13.11.06s.09.06.06.05a1.06,1.06,0,0,0-.35,0c-.12,0-.1.09,0,0a4.2,4.2,0,0,0,1.47-1.07,17.58,17.58,0,0,0,1.74-2,52.8,52.8,0,0,0,3.21-5.06c.5-.9,1-1.81,1.49-2.74l1.42-2.77,4.12,1.34a48.28,48.28,0,0,1-4.47,12.85,23,23,0,0,1-2,3.17,12.12,12.12,0,0,1-3.42,3.06,7.42,7.42,0,0,1-3,1,7.17,7.17,0,0,1-3.49-.57,19.58,19.58,0,0,1-1.91-1c-.55-.34-1.08-.68-1.58-1a60.14,60.14,0,0,1-5.4-4.33c-1.68-1.49-3.27-3-4.84-4.57-3.11-3.13-6-6.31-8.89-9.71Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.1,217.8l-2.32-4.18a3.93,3.93,0,0,1,2-5.55h0a4.26,4.26,0,0,1,5.84,4.36,24.18,24.18,0,0,1-.47,3,2.33,2.33,0,0,1-1.82,1.74Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.72,208.87c1.55-6.74,9.33-9.38,13.51-1.72,5.44,9.95,14.73,20.27,14.73,20.27l7.37-9.62,6.57,2.65s-5,20-15.66,16.91S125.14,215.75,126.72,208.87Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.72,208.87c1.55-6.74,9.33-9.38,13.51-1.72,5.44,9.95,14.73,20.27,14.73,20.27l7.37-9.62,6.57,2.65s-5,20-15.66,16.91S125.14,215.75,126.72,208.87Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 167.31,
    cy: 172.98,
    r: 3.71,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161.95,
    cy: 168.4,
    r: 3.71,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 155.1,
    cy: 167.04,
    r: 3.71,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148.77,
    cy: 169.98,
    r: 3.71,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.77,176.11a3.71,3.71,0,1,1-3.71-3.71A3.71,3.71,0,0,1,149.77,176.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.67,184.58a3.15,3.15,0,1,1,1.16-3.93A2.92,2.92,0,0,1,148.67,184.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.06,180.63s-1-10,6.42-12.65,14.05,4.13,14.05,4.13l.52,2.58-4.05.65-6.71.77L152,177.44l-4.29,4.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.75,182.15s5.43-5.3,15.25-5.47a5.49,5.49,0,0,1,3.07.78.3.3,0,0,0,.44-.36l-1.19-3.36a1.28,1.28,0,0,0-1-.85c-2.07-.33-8.09-.65-15.78,4.65a1.29,1.29,0,0,0-.55,1Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.92,179.33l-.06,1c3.54-2.2,12.12-6.87,18.06-4.86l-.32-.91C159.6,172.9,151.67,177,147.92,179.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.45,185.53a6.35,6.35,0,0,0,3.6,3.27c2.1.74,3.3-1.11,2.83-3.17-.41-1.86-2-4.48-4.18-4.33A2.86,2.86,0,0,0,144.45,185.53Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.54,174.86c-.58,1.56-2,2.49-3.07,2.08s-1.54-2-1-3.59,2-2.49,3.07-2.08S159.12,173.29,158.54,174.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,173.48c-.59,1.56-2,2.49-3.07,2.08s-1.54-2-1-3.58,2-2.5,3.07-2.08S156.6,171.92,156,173.48Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentsRafiki);
export default __webpack_public_path__ + "static/media/Students-rafiki.a9620c2bf6fe93b2026a1500b95eeb6c.svg";
export { ForwardRef as ReactComponent };